/**
 * Catalog API client.
 * Local http://localhost (make local) → same-origin /catalog/v1 proxy.
 * Production web + Electron file:// → https://catalog.rd1.io/v1
 * Override: globalThis.CATALOG_API_URL (e.g. http://localhost:3001/v1).
 */
const PROD_CATALOG = 'https://catalog.rd1.io/v1';

function baseUrl() {
    const env = globalThis.CATALOG_API_URL;
    if (env) return String(env).replace(/\/+$/, '');
    const host = globalThis.location?.hostname || '';
    if (host === 'localhost' || host === '127.0.0.1') return '/catalog/v1';
    return PROD_CATALOG;
}

export function assetUrl(id, revision = 1) {
    return `${baseUrl()}/icons/${id}/assets/${revision}.svg`;
}

function mapHits(results = []) {
    return results.map((r) => ({
        id: r.id,
        title: r.title || r.canonicalName || String(r.id),
        canonicalName: r.canonicalName,
        revision: r.revision || 1,
        url: assetUrl(r.id, r.revision || 1),
    }));
}

async function getJson(path) {
    const res = await fetch(`${baseUrl()}${path}`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`catalog ${res.status}`);
    return res.json();
}

/**
 * Lexical search over the catalog. Returns a small projection for the picker grid.
 * Throws on network/HTTP errors — caller shows "каталог недоступен".
 */
export async function search(q, lang = 'ru', limit = 48) {
    const data = await getJson(`/search?q=${encodeURIComponent(q)}&lang=${encodeURIComponent(lang)}&mode=lexical&limit=${limit}`);
    return mapHits(data.results);
}

export async function taxonomy(lang = 'ru') {
    const data = await getJson(`/taxonomy?lang=${encodeURIComponent(lang)}`);
    return data.domains || [];
}

export async function browse({ lang = 'ru', limit = 80, offset = 0, domain = '' } = {}) {
    const qs = new URLSearchParams({ lang, limit: String(limit), offset: String(offset) });
    if (domain) qs.set('domain', domain);
    const path = domain ? `/taxonomy/icons?${qs}` : `/browse?${qs}`;
    const data = await getJson(path);
    return { total: data.total ?? 0, results: mapHits(data.results) };
}
